import React, { useEffect, useState } from 'react'
import { Button, Image, Modal } from 'react-bootstrap';
import { MediaBaseUrl } from '../../../../../../actions/api';
import { deleteCollaborator, updateCollaborator } from '../../../../../../actions/appsMoreAction';
import { SWAL_FIRE, TOAST_DISMISS, TOAST_ERROR, TOAST_LOADING, TOAST_SUCCESS } from '../../../../../../utils';
import { FontAwesomeIcon } from '../../../../../CommonComponents/AssetsHelper';

export default function ManageCollaborator(props) {
	const [state, setState] = useState(false);
	const [data, setData] = useState([]);
	const [value, setValue] = useState()
	const [spinner, setspinner] = useState(false);

	useEffect(() => {
		props.getNewData()
		setState(false)
	}, [])

	useEffect(() => {
		setData(props.userData)
	}, [props?.userData])




	const deleteRule = (id) => {
		SWAL_FIRE({
			title: "Are you sure?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Yes",
			confirmButtonColor: "#FF4051",
			cancelButtonColor: "#E4E6EF",
			cancelButtonText: "No",
		}).then((result) => {
			if (result.value) {
				TOAST_LOADING()
				deleteCollaborator(id).then((res) => {
					if (res.status == 200) {
						TOAST_DISMISS()
						TOAST_SUCCESS(`Collaborator Delete successfully.`);
						props.getNewData()
					}
				})
			} else if (result.dismiss === "cancel") {
			}
		});
	}

	const submitData = (e, cid, collaboratorRole, collaboratorId) => {
		e.preventDefault();
		setspinner(true);
		TOAST_LOADING()
		updateCollaborator({ collaboratorId, id: cid, collaboratorRole: value == undefined ? collaboratorRole : value }).then(() => {
			TOAST_DISMISS()
			setspinner(false);
			TOAST_SUCCESS(`Collaborator Update successfully.`);
			props.onHide()
		}).catch(() => {
			TOAST_DISMISS()
			setspinner(false);
			TOAST_ERROR(`Error`);
			props.onHide()
		})
	}


	return (
		data &&
		<Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			onHide={() => { props.onHide(); setState(false) }}
		>
			<Modal.Header className="personalize_wt" closeButton>
				<Modal.Title className="modal-title"> Manage Collaborator
				</Modal.Title>
			</Modal.Header>
			{data.length > 0 ? <>
			<Modal.Body className="modal-body">
				<div className="tab-content collabWrapC">
					<div className="tab-pane fade active show">
						<div className="table-scrollable table-scrollable-borderless globalTblList">
							<table className="table mb-0">
								<thead>
									<tr className="uppercase">
										<th> User Name   </th>
										<th> Status   </th>
										<th style={{ textAlign: 'right' }}>Action</th>
									</tr>
								</thead>
								<tbody>
									{data.map((item, index) => <tr id={`collab${item.cid}`} key={item.collaboratorRole}>
										<td>{item.emailId} </td>
										<td>{item.collaboratorStatus == 1 ? `Pending` : `Accepted`}</td>
										<td>
											<div className="d-flex algin-items-center justify-content-end">
												<Button variant='link' className="me-2 p-2" onClick={state !== index ? () => setState(index) : null} data-original-title="Edit">
													<FontAwesomeIcon type={'solid'} icon={'pencil'} iconClass="fs-6"/>
												</Button>

												<Button variant='link' className='p-2' onClick={() => deleteRule(item.cid)} title="delete">
													<FontAwesomeIcon type={'solid'} icon={'trash-can'} iconClass="fs-6"/>
												</Button>
											</div>
											<div className="addCollabrtr Editcollaborator1" style={{ display: state === index ? '' : 'none' }}>

												<form onSubmit={(e) => submitData(e, item.cid, item.collaboratorRole, item.collaboratorId)} className="maintainPopUp noLoader" id="CollaboratorIndexForm">
													<div style={{ display: 'none' }}><input type="hidden" name="_method" value="POST" /></div>
													<div className="allPrmissins">
														<div className="checkbox-list">
															<label className="" htmlFor="selecctall1">
																Select Permission
															</label>
														</div>
														<div className="separator separator-dashed my-3"></div>
														<div className="col-md-4 mb-3">
															<div className="radio-inline">
																<label className="radio radio-outline radio-primary d-flex align-items-center">
																	<input type="radio" name="data[Collaborator][collaboratorRole]" id="CollaboratorCollaboratorRole1" defaultChecked={item.collaboratorRole == 1 ? true : false} value='1' onChange={(e) => setValue(e.target.value)} />
																	<span></span>Admin
																</label>
															</div>
														</div>

														<div className="col-md-4 mb-3">
															<div className="radio-inline">
																<label className="radio radio-outline radio-primary d-flex align-items-center">
																	<input type="radio" name="data[Collaborator][collaboratorRole]" id="CollaboratorCollaboratorRole2" defaultChecked={item.collaboratorRole == 2 ? true : false} onChange={(e) => setValue(e.target.value)} value='2' />
																	<span></span>Editor
																</label>
															</div>
														</div>

														<div className="col-md-4 mb-3">
															<div className="radio-inline">
																<label className="radio radio-outline radio-primary d-flex align-items-center">
																	<input type="radio" name="data[Collaborator][collaboratorRole]" id="CollaboratorCollaboratorRole3" defaultChecked={item.collaboratorRole == 3 ? true : false} onChange={(e) => setValue(e.target.value)} value='3' />
																	<span></span>Moderator
																</label>
															</div>
														</div>

														<input type="hidden" name="collaboratorId" value="89297" />
														<Button variant='primary' type="submit" className={`${spinner ? `spinner spinner-white spinner-right disabled` : null}`} >Update</Button>
													</div>
												</form></div>
										</td>
									</tr>)}
								</tbody>
							</table>
							
						</div>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<div className="d-flex align-items-center justify-content-end w-100">
					<Button variant='primary' onClick={() => props.isCollaborator()} id="initAddCollaborator">Add Another Collaborator</Button>
				</div>
			</Modal.Footer> </>:
			<Modal.Body>
				<div className="text-center">
					<Image src={`${MediaBaseUrl}error/drop-box.svg`} className="commanImgModal img-fluid" height={150} width={200} alt="Upgrade Plan" />
					<p className="commanPeraModal my-3">Oops! Nothing found</p>
					<Button variant='primary' onClick={() => props.isCollaborator()} className='mb-3' >Add Collaborator</Button>
				</div>
			</Modal.Body>}
		</Modal>
	)
}
